function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L90 0L90 59L0 59L0 0Z",
  id: "nodejs_path_1"
}), /*#__PURE__*/React.createElement("clipPath", {
  id: "nodejs_mask_1"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#nodejs_path_1"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "nodejs-1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L90 0L90 59L0 59L0 0Z",
  id: "nodejs-1-(Background/Mask)",
  fill: "none",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#nodejs_mask_1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.2646 5.86108L10.1322 0L0 5.86108L0 17.5834L10.1322 23.4445L20.2646 17.5834L20.2646 5.86108Z",
  transform: "translate(22.484375 13.511719)",
  id: "Vector",
  fill: "#D8D8D8",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.7345 19.6246L10.1315 23.445L0 17.5838L0 5.86125L10.1315 0L16.2717 3.55356C16.8869 6.15378 17.2745 8.84066 17.416 11.5918L13.6617 13.7634L13.6617 9.67987L10.1315 7.639L6.60129 9.67987L6.60129 13.7634L10.1315 15.8042L16.7345 19.6246Z",
  transform: "translate(72.521484 13.512695)",
  id: "Vector",
  fill: "#FFFFFF",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.93381 1.13773L1.96699 0L0 1.13773L0 3.41319L1.96699 4.5511L3.93381 3.41319L3.93381 1.13773Z",
  transform: "translate(80.68555 22.958984)",
  id: "Vector",
  fill: "#FFFFFF",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.6987 21.3196L10.9413 17.4569L10.9413 9.53281L7.56738 7.58018L4.19326 9.53264L4.19326 17.4568L0.356309 19.6505C0.121289 17.7881 0 15.889 0 13.9622C0 10.4326 0.404121 6.99687 1.17 3.70079L7.56738 0L17.6987 5.86143L17.6987 21.3196Z",
  transform: "translate(0 13.512695)",
  id: "Vector",
  fill: "#FFFFFF",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.2935 0L20.2935 11.7051L0 11.7051L0 0L20.2935 0Z",
  transform: "matrix(0.4992441 0.8664614 -0.8664614 0.4992441 32.621708 13.519897)",
  id: "Vector",
  fill: "#FFFFFF",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.47906 6.0379L0 0L0 11.7223L3.47906 6.0379Z",
  transform: "translate(22.484375 19.373047)",
  id: "Vector",
  fill: "#F0F0F0",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.1324 5.86108L0 0L6.75457 11.7218L10.1324 5.86108Z",
  transform: "translate(32.61621 13.511719)",
  id: "Vector",
  fill: "#F0F0F0",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.5293 15.552L10.1333 13.5866L0 19.4478L0 31.1703L10.1333 37.0316L20.2648 31.1703L20.2648 3.61238L13.5293 0L13.5293 15.552ZM10.1331 29.2161L6.75527 27.2617L6.75527 23.3548L10.1331 21.4004L13.5109 23.3548L13.5109 27.2617L10.1331 29.2161Z",
  transform: "translate(47.387695 -0.07421875)",
  id: "Vector",
  fill: "#FFFFFF",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(34.228516 34.97754)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.93172 1.55932C3.10219 1.55932 1.84957 1.79831 1.84957 2.81452C1.84957 3.83073 5.40915 3.83073 6.76143 4.22911C8.11372 4.62749 9.30674 5.66361 8.71014 7.49666C8.11354 9.32971 6.28401 9.5289 3.46026 9.5289C0.636507 9.5289 0 7.1777 0 6.26135L1.59082 6.26135C1.59082 6.26135 1.39183 7.69584 3.26109 7.93484C5.13035 8.17383 6.9177 8.30839 7.15869 6.8591C7.47686 4.94627 1.1134 5.90277 0.556524 4.02992C0.0861329 2.44748 0.357538 0.363996 3.53936 0.0450437C6.72117 -0.273909 8.47108 1.13364 8.47108 3.23298L6.96006 3.27278C6.96006 3.27278 6.76108 1.55932 4.93172 1.55932Z",
  transform: "translate(8.408203 7.3154297)",
  id: "Vector",
  fill: "#FFFFFF",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.51721 20.0921C5.28434 21.1143 7.49321 19.8365 7.49321 17.7921L7.49321 14.2271L7.49321 7.66613L6.05971 7.66613L6.05971 17.3927C6.05971 18.5091 4.8535 19.2071 3.88828 18.6486L1.4335 17.2287L1.4335 6.84823L10.4059 1.65852L19.3783 6.84823L19.3783 17.2287L10.4059 22.4184L7.82121 20.9233L6.13336 21.6053L10.4057 24.0768L20.8116 18.0572L20.8116 6.01924L10.4059 0L0 6.01959L0 18.0577L0.000177026 18.0577L3.51721 20.0921Z",
  id: "Vector",
  fill: "#FFFFFF",
  fillRule: "evenodd",
  stroke: "none"
}))));

var SvgNodejs = function SvgNodejs(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90px",
    height: "59px",
    viewBox: "0 0 90 59",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNodejs, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/nodejs.29784024.svg";
export { ForwardRef as ReactComponent };